// @ts-nocheck
/* eslint-disable */
import React, { PureComponent } from 'react';
import { css } from '@emotion/css';
import DiscoAdsCreatorButtonsWrapper from './DiscoAdsCreatorButtonsWrapper';

const formWrapperDefaultStyles = {
  viewComponentContainer: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  formContainer: {
    marginLeft: '50px',
    marginRight: '50px',
    marginTop: '40px',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '455px',
  },
  buttonsContainer: {
    alignSelf: 'flex-end',
    marginBottom: '20px',
  },
};

class DiscoAdsCreatorViewComponentWrapper extends PureComponent {
  _generateFormStyles = () => {
    const { customStyles } = this.props;

    return Object.keys(formWrapperDefaultStyles).reduce((acc, styleKey) => {
      if (customStyles && customStyles[styleKey]) {
        acc[styleKey] = css(customStyles[styleKey]);
        return acc;
      }
      acc[styleKey] = css(formWrapperDefaultStyles[styleKey]);
      return acc;
    }, {});
  };

  render() {
    const { viewComponentContainer, formContainer, buttonsContainer } = this._generateFormStyles();
    const { saveAndContinueButtonIsDisabled, onSaveClick, saveButtonCopy, onCancelClick } = this.props;
    return (
      <div className={viewComponentContainer}>
        <form className={formContainer} onSubmit={(e) => e.preventDefault()}>
          {this.props.children}
        </form>
        <div className={buttonsContainer}>
          <DiscoAdsCreatorButtonsWrapper
            saveAndContinueButtonIsDisabled={saveAndContinueButtonIsDisabled}
            onSaveClick={onSaveClick}
            saveButtonCopy={saveButtonCopy}
            onCancelClick={onCancelClick}
          />
        </div>
      </div>
    );
  }
}

export default DiscoAdsCreatorViewComponentWrapper;
